import { Pagination, SuccessResponse } from "common/common.interface";
import { environment } from "common/environment";
import { DevisFilter } from "modules/devis/types/devis.interface";
import {
  BonDeCommande,
  CreateBonDeCommandePayload,
} from "modules/bonDeCommande/types/bonDeCommande.interface";

export interface BonDeCommandeBackend {
  getBonDeCommandes(
    page: number,
    limit: number,
    searchName: string | undefined,
    filters?: DevisFilter
  ): Promise<Pagination<BonDeCommande>>;
  getBonDeCommande(id: string): Promise<BonDeCommande>;
  createBonDeCommande(
    workspaceId: string,
    payload: CreateBonDeCommandePayload,
    commandeId: string | undefined
  ): Promise<BonDeCommande>;
  updateBonDeCommande(
    id: string,
    payload: CreateBonDeCommandePayload
  ): Promise<BonDeCommande>;
  archiveBonDeCommande(id: string): Promise<SuccessResponse>;
  downloadBonDeCommande(id: string): Promise<ArrayBuffer>;
}

let bonDeCommandeBackendInstance: BonDeCommandeBackend | undefined;

export async function getBonDeCommandeBackend(): Promise<BonDeCommandeBackend> {
  if (bonDeCommandeBackendInstance === undefined) {
    const mod = await import(`./${environment.ARTICLE_BACKEND}`);
    bonDeCommandeBackendInstance = new mod.default() as BonDeCommandeBackend;
  }
  return bonDeCommandeBackendInstance;
}
